import { IxSubMenu } from './IxSubMenu.js';

window.customElements.define('ix-sub-menu', IxSubMenu);
